const $ulmStrip = $('#ulmStrip');
let ulmStrip_locations = [];

$(document).ready(function() {
    // console.log('0');

    if ($ulmStrip.length) {
        // console.log('1'); 
        ulmStrip_placement();
        ulmStrip_loadLocations();
    }

    const today = new Date();
    let d = (today.getDate() < 10) ? '0' + today.getDate() : today.getDate();
    const mFix = today.getMonth() + 1;
    let m = (mFix < 10) ? '0' + mFix : mFix;
    $ulmStrip.find('.form-control[name="date"]').prop({
        'value': today.getFullYear() + '-' + m + '-' + d,
        'min': today.getFullYear() + '-' + m + '-' + d
    });

    $ulmStrip.find('.form-control[name="date"]').on('change', function(e) {
        ulmStrip_validateSubmitBtn();
        ulmStrip_setDateValue();
        e.preventDefault();
    });

    // Das Formular soll nur über "Suchen" abgeschickt werden können
    $ulmStrip.find('.form-control[name="date"]').on('keydown', function(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
        }
    });

    $('#ulmStripForm').on('submit', function(e) {
        e.preventDefault();

        const action = new URL($(this).attr('action'));
        const params = new URLSearchParams(action.hash.replace('#', ''));
        const lat = params.get('lat');
        const lon = params.get('lon');
        if ((lat === 'null' && lon === 'null') || !action.hash) {
            return;
        }
        window.location.href = action.toString();
    });

});

const ulmStrip_placement = function() {

    // wenn #ttgHeaderOnDetailSite nicht vorhanden ist, aber .ttgNCEHeaderSliderWrapper (= Header Content Element ist vorhanden), dann soll #ttgIndividualHeaderHTML nach .ttgNCEHeaderSliderWrapper eingefügt werden
    if (!$('#ttgHeaderOnDetailSite').length && $('.ttgNCEHeaderSliderWrapper').length) {
        $('#ttgIndividualHeaderHTML')
            .hide()
            .appendTo('.ttgNCEHeaderSliderWrapper')
            .show();
    }
};

const ulmStrip_validateSubmitBtn = function() {
    const action = new URL($('#ulmStripForm').attr('action'));
    const params = new URLSearchParams(action.hash.replace('#', ''));
    const lat = params.get('lat');
    const lon = params.get('lon');
    if ((lat === 'null' && lon === 'null') || !action.hash) {
        $('#ulmStripSubmitBtn').css('cursor', 'not-allowed');
    } else {
        $('#ulmStripSubmitBtn').css('cursor', 'pointer');
    }
};

const ulmStrip_loadLocations = function() {

    let locations = [{
        label: $ulmStrip.find('#standort').data('naehe'),
        desc: $ulmStrip.find('#standort').data('standort'),
        value: {
            geoLocator: true
        },
        icon: "fas fa-street-view"
    }];

    const ulm_StriphashObj = generateObjectFromHash(window.location.hash); // Function aus tdLists.js
    if (ulm_StriphashObj.loctype === 'given') {
        locations.push({
            label: $ulmStrip.find('#standort').data('naehe'),
            desc: ulm_StriphashObj.located,
            value: {
                lat: ulm_StriphashObj.lat,
                lon: ulm_StriphashObj.lon
            },
            icon: "fas fa-search-location"
        });
    }

    var exp = ($('#ulmStrip [name="standort"]').data('ortederexperience') == '1') ? $('#ulmStrip [name="standort"]').data('exp') : 'webarchitektur-meta';

    $.ajax({
        method: 'POST',
        url: window.location.protocol + "//" + window.location.host + "/?type=2090",
        data: {
            experience: exp,
            template: "ET2014A_LIGHT.json",
            type: "City",
            facets: false,
            sort: "title asc"
        },
        dataType: 'jsonp',
        beforeSend: function(xhr, settings) {},
        success: function(response, status, xhr) {
            if (response && response.items.length) {
                $.each(response.items, function(i, v) {
                    let location = {
                        label: v.city,
                        desc: v.district,
                        value: {
                            lat: v.geo.main.latitude,
                            lon: v.geo.main.longitude,
                        },
                        icon: (v.type === 'City') ? 'fas fa-map-marker-alt' : 'fas fa-bullseye',
                    };
                    locations.push(location);
                });
            }
        },
        complete: function(xhr, status) {
            ulmStrip_setupAutoComplete(locations);
            ulmStrip_setValues();
        }
    });
};

const ulmStrip_setupAutoComplete = function(locations) {

    $ulmStrip.find('.form-control[name="standort"]').autocomplete({
        source: locations,
        minLength: 0,
        focus: function(e, ui) {
            let value = ui.item.label;
            if (ui.item.desc && ui.item.desc != "" && !ui.item.value.geoLocator) {
                value += ', ' + ui.item.desc;
            }
            $(this)
                .val(value)
                .closest('.input-group').find('.input-group-addon')
                .empty()
                .html('<span class="i ' + ui.item.icon + ' fa-fw"></span>');

            return false;
        },
        select: function(e, ui) {
            $ulmStrip.find('.geoLocatorErrorMsg').remove();
            $ulmStrip.find('.errorMsg').removeClass('errorMsg');

            let value = ui.item.label;
            if (ui.item.desc && ui.item.desc != "" && !ui.item.value.geoLocator) {
                value += ', ' + ui.item.desc;
            }
            $(this)
                .val(value)
                .closest('.input-group').find('.input-group-addon')
                .empty()
                .html('<span class="i ' + ui.item.icon + ' fa-fw"></span>');

            if (ui.item.value.geoLocator) {
                ulmStrip_geoLocator();
            } else {
                let located = ui.item.label + ', ' + ui.item.desc;
                let loctype = 'default';
                if (ui.item.icon === 'fas fa-search-location') {
                    located = ui.item.desc;
                    loctype = 'given';
                }
                $(this).data({
                    lat: ui.item.value.lat,
                    lon: ui.item.value.lon,
                    located: located,
                    loctype: loctype
                });
                ulmStrip_setFormValues(ui.item.value.lat, ui.item.value.lon, located, loctype);
                ulmStrip_validateSubmitBtn();
            }
            return false;
        },
        close: function(e, ui) {
            $(e.target).blur();
        }
    }).focus(function() {
        $(this).val('').autocomplete('search', '');
        document.getElementById("ulmStrip").scrollIntoView();
    }).autocomplete("instance")._renderItem = function(ul, item) {
        let desc = "";
        if (item.desc && item.desc != "") {
            desc = ', <span class="desc">' + item.desc + '</span>';
        }
        return $("<li>")
            .append('<div class="ac-left"><span class="i ' + item.icon + ' fa-fw"></span></div><div class="ac-right"><span class="label">' + item.label + '</span>' + desc + '</div>')
            .appendTo(ul);
    };

};

const ulmStrip_setDateValue = function() {
    const date = $ulmStrip.find('.form-control[name="date"]').val();
    const action = new URL($('#ulmStripForm').attr('action'));
    const params = new URLSearchParams(action.hash.replace('#', ''));
    const lat = params.get('lat');
    const lon = params.get('lon');
    action.hash = `#lat=${ lat }&lon=${ lon }&date=${ date }`;
    $('#ulmStripForm').attr('action', action.toString());
};

const ulmStrip_setFormValues = function(lat, lon, located = 'true', loctype = 'default') {
    const form = $("#ulmStripForm").closest('form');
    const action = new URL(form.attr('action'));
    const date = $ulmStrip.find('.form-control[name="date"]').val()
    action.hash = `#lat=${ lat }&lon=${ lon }&date=${ date }&located=${ encodeURIComponent(located) }&loctype=${ loctype }`;
    form.attr('action', action.toString());
};

const ulmStrip_setValues = function(historyObj) {

    let ulm_StriphashObj = {};
    if (window.location.hash) { // Hash Parameter vorhanden
        ulm_StriphashObj = generateObjectFromHash(window.location.hash); // Function aus tdLists.js
    } else if (historyObj) { // History API Obj übergeben
        ulm_StriphashObj = historyObj;
    }

    if (ulm_StriphashObj.date) {
        const givenDate = new Date(ulm_StriphashObj.date);
        const minDate = new Date($ulmStrip.find('.form-control[name="date"]').prop('min'));
        if (givenDate <= minDate) {
            $ulmStrip.find('.form-control[name="date"]').val($ulmStrip.find('.form-control[name="date"]').prop('min'));
        } else {
            $ulmStrip.find('.form-control[name="date"]').val(ulm_StriphashObj.date);
        }
    }

    if (!ulm_StriphashObj.loctype) {
        $ulmStrip.loctype = 'default';
    }

    if (ulm_StriphashObj.located && ulm_StriphashObj.located !== 'true') {
        $ulmStrip.find('.form-control[name="standort"]').data({
            lat: ulm_StriphashObj.lat,
            lon: ulm_StriphashObj.lon,
            located: ulm_StriphashObj.located,
            loctype: ulm_StriphashObj.loctype
        }).val((ulm_StriphashObj.loctype === 'given') ? $ulmStrip.find('#standort').data('naehe') + ', ' + decodeURIComponent(ulm_StriphashObj.located) : decodeURIComponent(ulm_StriphashObj.located));
        if (ulm_StriphashObj.loctype === 'given') {
            $ulmStrip.find('.form-control[name="standort"]')
                .closest('.input-group').find('.input-group-addon')
                .empty()
                .html('<span class="i fas fa-search-location fa-fw"></span>');
        } else {
            $ulmStrip.find('.form-control[name="standort"]')
                .closest('.input-group').find('.input-group-addon')
                .empty()
                .html('<span class="i fas fa-map-marker-alt fa-fw"></span>');
        }
    } else {
        ulmStrip_geoLocator();
    }

};

const ulmStrip_geoLocator = function() {

    navigator.geolocation.getCurrentPosition(
        function(position) {

            $ulmStrip.find('.form-control[name="standort"]').data({
                lat: position.coords.latitude,
                lon: position.coords.longitude,
                located: 'true',
                loctype: 'default'
            })
                .val($ulmStrip.find('#standort').data('naehe') + ', ' + $ulmStrip.find('#standort').data('standort'))
                .closest('.input-group').find('.input-group-addon')
                .empty()
                .html('<span class="i fas fa-street-view fa-fw"></span>');

            ulmStrip_setFormValues(position.coords.latitude, position.coords.longitude);

        },
        function(error) {

            window.geoStatus = 'not-located';
            navigator.permissions.query({ name: 'geolocation' }).then(function(status) {
                if (status.state !== 'granted') {
                    if ($ulmStrip.find('.form-control[name="standort"]').val() == 'In der Nähe') {
                        window.geoStatus = 'geolocation-hinweis';
                        $('<div />').addClass('geoLocatorErrorMsg').html(
                            $ulmStrip.find('.form-control[name="standort"]').data('geolocatorerrormsg')
                        ).appendTo(
                            $ulmStrip.find('.form-control[name="standort"]').closest('.input-group').addClass('errorMsg')
                        );
                        ulmStrip_setFormValues('null', 'null');
                        ulmStrip_validateSubmitBtn();
                    }
                }
            });

            setTimeout(function() {
                if (window.geoStatus === 'not-located') {
                    // Simulate selecting the "Linz" option in ui-autocomplete
                    const linzOption = {
                        label: 'Linz',
                        desc: 'Linz(Stadt)',
                        value: {
                            lat: '48.306',
                            lon: '14.2866'
                        },
                        icon: 'fas fa-map-marker-alt'
                    };

                    // Set the input's value and data as if the user had selected the option
                    $ulmStrip.find('.form-control[name="standort"]')
                        .val(linzOption.label + ', ' + linzOption.desc)
                        .data({
                            lat: linzOption.value.lat,
                            lon: linzOption.value.lon,
                            located: encodeURIComponent(linzOption.label + ', ' + linzOption.desc),
                            loctype: 'default'
                        })
                        .closest('.input-group')
                        .find('.input-group-addon')
                        .empty()
                        .html('<span class="i ' + linzOption.icon + ' fa-fw"></span>');

                    // Optionally, trigger the autocompleteselect event to notify any listeners

                    $ulmStrip.find('.form-control[name="standort"]').trigger("autocompleteselect", { item: linzOption });
                    ulmStrip_setFormValues(linzOption.value.lat, linzOption.value.lon, linzOption.label + ', ' + linzOption.desc);
                    ulmStrip_validateSubmitBtn();
                }
            }, 1000);

        }
    );

};